// toolbar.js
import { DraggableNode } from './draggableNode';

export const PipelineToolbar = () => {
    return (
        <div className="bg-white border-b border-gray-200 px-6 py-3 shadow-sm z-10">
            <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 border-r border-gray-200 pr-4 mr-2">
                    <span className="text-gray-900 font-bold text-lg select-none">VectorShift</span>

                </div>

                <DraggableNode type='customInput' label='Input' />
                <DraggableNode type='llm' label='LLM' />
                <DraggableNode type='customOutput' label='Output' />
                <DraggableNode type='text' label='Text' />
                <DraggableNode type='filter' label='Filter' />
                <DraggableNode type='transform' label='Transform' />
                <DraggableNode type='combine' label='Combine' />
                <DraggableNode type='condition' label='Condition' />
                <DraggableNode type='print' label='Print' />
            </div>
        </div>
    );
};
